module.exports = __webpack_public_path__ + "static/media/history_phat.387bdaa0.png";